import { GetServerSidePropsContext, GetServerSideProps } from "next";
import { redirectToHomepage } from "@a101/utils/redirect";
import { pageGuard } from "@a101/components/general/page-guard";

// ========= NEXT =========
/**
 * Check for session and redirect user to apporpriate homepage
 */
const getServerSidePropsFunc = async (context: GetServerSidePropsContext) => {
  return redirectToHomepage(context);
};
export const getServerSideProps: GetServerSideProps = pageGuard({
  getServerSidePropsFunc
});

// ========= COMPONENT =========
const Index = () => {
  return <></>;
};
export default Index;